import { Inbox } from "lucide-react";

interface EmptyStateProps {
  icon?: React.ElementType;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
}

export function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mb-5">
        <Icon size={28} className="text-slate-400" />
      </div>
      <h3 className="text-base font-semibold text-slate-700 font-display">
        {title}
      </h3>
      {description && (
        <p className="text-sm text-slate-400 mt-1.5 max-w-sm">{description}</p>
      )}
      {action && (
        <button className="btn btn-primary mt-5" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
